import React from 'react';
import PropTypes from 'prop-types';

import AttributeDef, { AttributeType } from 'models/configuration/attribute_def';
import EditableDateCustomAttribute from './editable_date_custom_attribute';
import EditablePercentCustomAttribute from './editable_percent_custom_attribute';
import EditableStringCustomAttribute from './editable_string_custom_attribute';

export function EditableCustomAttribute({ value, def, renderProps }) {
  if (def.type === AttributeType.DATE) {
    return <EditableDateCustomAttribute def={def} value={value} />;
  } else if (def.type === AttributeType.PERCENT) {
    return <EditablePercentCustomAttribute def={def} value={value} renderProps={renderProps} />;
  }
  return <EditableStringCustomAttribute def={def} value={value} />;
}

EditableCustomAttribute.propTypes = {
  value: PropTypes.string,
  def: PropTypes.instanceOf(AttributeDef).isRequired,
  renderProps: PropTypes.object,
};

export default EditableCustomAttribute;



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/customer/summary/custom_attributes/editable_custom_attribute.jsx